module.exports = __webpack_public_path__ + "img/cruise-icon.28ace504.png";